import React, { PropsWithChildren } from "react";
import styles from "./page-subtitle.module.scss";

export interface IPageSubtitleProps {
  subtitle: string;
}

const PageSubtitle = (props: PropsWithChildren<IPageSubtitleProps>) => {
  return (
    <div className={styles.root} data-testid="page-subtitle">
      <h2 data-testid="page-subtitle-text" className={styles.subtitle}>
        {props.subtitle}
      </h2>
      {props.children && <div className={styles.content}>{props.children}</div>}
    </div>
  );
};

export default PageSubtitle;
